import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "note" };
const _hoisted_2 = {
    key: 0,
    id: "nr_cookieconsent",
    class: "cookieconsent cookieconsent--show alert alert-dismissible fade show",
    role: "alert"
};
const _hoisted_3 = { class: "cookieconsent__message" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = { class: "container mt-3 bg-light border" };
const _hoisted_6 = { class: "row pt-2 pb-2" };
const _hoisted_7 = { class: "col-6 text-center" };
const _hoisted_8 = { class: "form-check-label" };
const _hoisted_9 = { class: "form-switch" };
const _hoisted_10 = { class: "col-6 text-center border-start" };
const _hoisted_11 = { class: "form-check-label" };
const _hoisted_12 = { class: "form-switch" };
const _hoisted_13 = { class: "cookieconsent__action mt-3" };
const _hoisted_14 = { "aria-hidden": "true" };
const _hoisted_15 = { "aria-hidden": "true" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", {
            class: "coockie-finger",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.setBannerVisible && _ctx.setBannerVisible(...args)))
        }, [
            _createVNode(_component_g_icon, {
                width: "32",
                height: "32",
                src: "/assets/icons/fingerprint.svg"
            }),
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$tc('client.Cookies')), 1)
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                        innerHTML: _ctx.$tc('custom.Messages.CookieConsent')
                    }, null, 8, _hoisted_4),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$tc('client.Cookies.Required')), 1),
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.enableDefault) = $event)),
                                        checked: "",
                                        disabled: ""
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.enableDefault]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$tc('client.Cookies.Statistics')), 1),
                                _createElementVNode("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.enableStatistik) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.enableStatistik]
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary w-100",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.setCookieAll && _ctx.setCookieAll(...args)), ["prevent"]))
                    }, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$tc('client.Cookies.AccecptAll')), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary w-100 btn-sm mt-2",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.setCoockieCustom && _ctx.setCoockieCustom(...args)), ["prevent"]))
                    }, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$tc('client.Cookies.Save')), 1)
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
